import { normalizeUser } from '../../utils/normalizeUser';
import { baseApi } from './baseApi';

export const searchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // 🔍 Search users
    searchAllUsers: builder.query({
      query: ({ query }) => ({
        url: '/Auth/GetProfileByNameOrID',
        params: { query },
      }),

      transformResponse: (response) => {
        const users = Array.isArray(response)
          ? response
          : response?.$values
          ? response.$values
          : response
          ? [response]
          : [];

        return users.map(normalizeUser);
      },
    }),
  }),
});

export const {
  useSearchAllUsersQuery,
  useLazySearchAllUsersQuery,
} = searchApi;
